module.exports = __webpack_public_path__ + "static/media/statepmg_icon.74ebcc19.svg";